import RescheduleAppointmentMapper from '@/modules/Telemedicine/services/mapper/HistoryAppointmentMapper/RescheduleAppointmentMapper/RescheduleAppointmentMapper'
import coreApi from '@/services/coreApi'
import { IConexaResponse, IEnumResponse, IQueryParams } from '@/types'
import { downloadFiles } from '@/utils/downloadFiles'
import qs from 'qs'
import { AttendingTableListProps } from '../../pages/Patient/components/Attending/components/AttendingTable/AttendingTable.types'
import { DataResults } from '../../pages/Patient/components/LinkedPsychologists/LinkedPsychologists.types'
import {
  EligibilityRequestBody,
  EligibilityWellhubParams,
  FormRegisterPatient,
} from '../../pages/Patient/components/RegisterPatient/RegisterPatient.types'
import {
  AnonymizeLgpdPayload,
  BlockOrUnblockPatientPayload,
  ResetPasswordPayload,
  SendAccessLinkPayload,
  UnlockLoginAttemptsPayload,
} from '../../pages/Patient/Patient.types'
import AttendingOutcomeListMapper from '../mapper/AttendingOutcomeListMapper/AttendingOutcomeListMapper'
import {
  AttendingOutcomeListTypeMapper,
  OutcomeDataResponse,
} from '../mapper/AttendingOutcomeListMapper/AttendingOutcomeListMapper.types'
import SendEligibilityCheck from '../mapper/EligibilityCheckMappers/EligibilityCheckRequestBody'
import EligibilityMapper from '../mapper/EligibilityCheckMappers/EligibilityMapper'
import EligibilityWellhub from '../mapper/EligibilityWellhubMappers/EligibilityWellhubMappers'
import ClinicInfoMapper from '../mapper/PatientPageMappers/ClinicInfoMapper'
import ClinicListMapper from '../mapper/PatientPageMappers/ClinicListMapper'
import PatientDependentsListMapper from '../mapper/PatientPageMappers/PatientDependentsListMapper'
import PatientHistoryMapper from '../mapper/PatientPageMappers/PatientHistoryMapper'
import PatientListMapper from '../mapper/PatientPageMappers/PatientListMapper'
import PatientListParamsMapper from '../mapper/PatientPageMappers/PatientListParamsMapper'
import SendAccessLinkPayloadMapper from '../mapper/PatientPageMappers/SendAccessLinkPayloadMapper'
import SendPasswordPayloadMapper from '../mapper/PatientPageMappers/SendPasswordPayloadMapper'
import { AttendanceListTypes } from '../mapper/PatientsMapper/AttendanceListMapper/AttendanceList.types'
import AttendanceListMapper from '../mapper/PatientsMapper/AttendanceListMapper/AttendanceListMapper'
import AttendanceSearchMapper from '../mapper/PatientsMapper/AttendanceSearchMapper/AttendanceSearchMapper'
import CallsDetailsListMapper from '../mapper/PatientsMapper/CallsDetailsListMapper/Events/CallsDetailsListMapper'
import ParticipantsMapper from '../mapper/PatientsMapper/CallsDetailsListMapper/Participants/ParticipantsMapper'
import { CollectionAttemptsListTypes } from '../mapper/PatientsMapper/CollectionAttempsOrOutcomeMapper/CollectionAttempsOrOutcome.types'
import CollectionAttemptsListMapper from '../mapper/PatientsMapper/CollectionAttempsOrOutcomeMapper/CollectionAttempsOrOutcomeMapper'
import { CreditCardTypes } from '../mapper/PatientsMapper/CreditCardMapper/CreditCard.types'
import CreditCardListMapper from '../mapper/PatientsMapper/CreditCardMapper/CreditCardMapper'
import {
  linkedPsychologists,
  PatientData,
} from '../mapper/PatientsMapper/PageLinkedPsychologistsMapper/LinkedPsychologists.types'
import HistoryDataMapper from '../mapper/PatientsMapper/PageLinkedPsychologistsMapper/LinkedPsychologistsHistoryMapper'
import PatientDataMapper from '../mapper/PatientsMapper/PageLinkedPsychologistsMapper/LinkedPsychologistsMapper'
import ParamsDataMapper from '../mapper/PatientsMapper/PageLinkedPsychologistsMapper/LinkedPsychologistsParamsMapper'
import { PatientDetails } from '../mapper/PatientsMapper/PatientDetailsMapper/PatientDetails.types'
import PatientDetailsMapper from '../mapper/PatientsMapper/PatientDetailsMapper/PatientDetailsMapper'
import PatientsServicesDetailsMapper from '../mapper/PatientsMapper/PatientsServicesDetailsMapper'
import PsychologistSearchFiltersMapper from '../mapper/PatientsMapper/PsychologistSearchFiltersMapper/PsychologistSearchFiltersMapper'
import { PsychologistSearchFiltersData } from '../mapper/PatientsMapper/PsychologistSearchFiltersMapper/PsychologistSearchFiltersMapper.types'
import PsychologistSearchListDataMapper from '../mapper/PatientsMapper/PsychologistSearchListDataMapper/PsychologistSearchListDataMapper'
import { PsychologistSearchList } from '../mapper/PatientsMapper/PsychologistSearchListDataMapper/PsychologistSearchListDataMapper.types'
import PsychologistSearchListMapper from '../mapper/PatientsMapper/PsychologistSearchListMapper/PsychologistSearchListMapper'
import { PsychologistSearchListParams } from '../mapper/PatientsMapper/PsychologistSearchListMapper/PsychologistSearchListMapper.types'
import { ViewOrAttachFilesTypes } from '../mapper/PatientsMapper/ViewOrAttachFilesMapper/ViewOrAttachFiles.types'
import ViewOrAttachFilesMapper from '../mapper/PatientsMapper/ViewOrAttachFilesMapper/ViewOrAttachFilesMapper'
import { ProfessionalData } from '../mapper/ProfessionalByPatientNameMapper/ProfessionalByPatientName.types'
import ProfessionalByPatientNameMapper from '../mapper/ProfessionalByPatientNameMapper/ProfessionalByPatientNameMapper'
import RegisterPatientMapper from '../mapper/RegisterPatientMapper/RegisterPatientMapper'
import {
  SmartSearchAnalysisData,
  SmartSearchAnalysisParam,
} from '../mapper/SmartSearchAnalysisMapper/SmartSearchAnalysis'
import {
  AttendancePayload,
  CallsDetailsMapper,
  CollectionAttemptsTypes,
  CreditCardResponseTypes,
  GetUserMapper,
  ImmediateAttachment,
  ManualBillingTypes,
  PayloadReschedule,
  PaymentReverseProps,
  RegisterPatientData,
  RemoveAttachment,
  SendAttachment,
  ServiceDetailsListData,
  SmartSearchProfessional,
  UnlinkProfessional,
  UploadPicturePatientProps,
} from './PatientServices.types'

class PatientServices {
  static async getPatientList(queryParams: IQueryParams) {
    const {
      data: { object },
    } = await coreApi.get('paciente/listar/paciente/backoffice', {
      params: PatientListParamsMapper.toPersistence(queryParams),
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'comma', encode: false })
      },
    })

    return {
      patientList: object?.data?.map(PatientListMapper.toDomain),
      total: object?.total,
    }
  }

  static async getClinicList(clinicName: string) {
    const {
      data: { object },
    } = await coreApi.get(`clinica/autocomplete/${clinicName}`)

    return object?.map(ClinicListMapper.toDomain)
  }

  static async getOwnerships() {
    const {
      data: { object },
    } = await coreApi.get('user/enums/ownership')

    return object
  }

  static async getStatus() {
    const {
      data: { object },
    } = await coreApi.get('user/enums/status')

    return object
  }

  static async getSituations() {
    const {
      data: { object },
    } = await coreApi.get('user/enums/situation')

    return object
  }

  static async getPsychologistSearchFilters(): Promise<PsychologistSearchFiltersData> {
    const {
      data: { object },
    } = await coreApi.get('pv/psicologos/filtros/v1')

    return PsychologistSearchFiltersMapper.toDomain(object)
  }

  static async getClinicPasswordCommunicationMedia(clinicId: string) {
    const {
      data: { object },
    } = await coreApi.get(
      `clinica/list/recovery-type/reset-patient-password/${clinicId}`,
    )

    return object
  }

  static async sendResetPassword(payload: ResetPasswordPayload) {
    await coreApi.post(
      'usuario/solicitar-troca-senha/paciente-backoffice',
      SendPasswordPayloadMapper.toPersistence(payload),
    )
  }

  static async getClinicCommunicationMedia(clinicId: string) {
    const {
      data: { object },
    } = await coreApi.get(`clinica/communications-media/${clinicId}`)

    return object
  }

  static async sendAccessLink(payload: SendAccessLinkPayload) {
    await coreApi.get(
      `paciente/gerar-mensagem-link-magico/${payload?.patientId}`,
      {
        params: SendAccessLinkPayloadMapper.toPersistence(payload),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )
  }

  static async getSettingClinicById(clinicId: string | number) {
    const {
      data: { object },
    } = await coreApi.get(`clinica/config/backoffice/${clinicId}`)

    return ClinicInfoMapper.toDomain(object)
  }

  static async unblockCreditCard(patientId: string) {
    await coreApi.put(`paciente/backoffice/unblock-credit-card/${patientId}`)
  }

  static async unlockLoginAttempts(payload: UnlockLoginAttemptsPayload) {
    await coreApi.post('usuario/desbloquear-tentativa-login', payload)
  }

  static async inactivatePatient(patientId: string) {
    await coreApi.get(`paciente/inativar/${patientId}`)
  }

  static async activatePatient(patientId: string) {
    await coreApi.get(`paciente/ativar/${patientId}`)
  }

  static async blockOrUnblockPatient(payload: BlockOrUnblockPatientPayload) {
    await coreApi.post(
      `clinica/bloquear-desbloquear-paciente/${payload?.id}/${payload?.block}`,
    )
  }

  static async anonymizeLgpd({ patientId, ...payload }: AnonymizeLgpdPayload) {
    await coreApi.post(
      `backoffice/paciente/${patientId}/anonimizar-lgpd`,
      payload,
    )
  }

  static async getPatientHistory(patientId: string) {
    const {
      data: { object },
    } = await coreApi.get(`paciente/backoffice/historico/${patientId}`)

    return PatientHistoryMapper.toDomain(object)
  }

  static async getPatientDependents(patientId: string) {
    const {
      data: { object },
    } = await coreApi.get(`paciente/backoffice/${patientId}/dependentes`)

    return object?.map(PatientDependentsListMapper.toDomain)
  }

  static async getPaymentReverse(params: PaymentReverseProps) {
    const {
      data: { object },
    } = await coreApi.post(`paciente/atendimento/estornar`, params)

    return object
  }

  static async getManualBillingWithOutcome(
    idAttendance: number,
    outcomeType: string,
    params: ManualBillingTypes,
  ) {
    const {
      data: { object },
    } = await coreApi.put(
      `backoffice/cobranca-manual/atendimento/${idAttendance}/concluir-com-desfecho/${outcomeType}`,
      params,
    )

    return object
  }

  static async getManualBillingBillOrReserve(
    idAttendance: number,
    outcomeType: string,
    params: ManualBillingTypes,
  ) {
    const {
      data: { object },
    } = await coreApi.put(
      `backoffice/cobranca-manual/atendimento/${idAttendance}/${outcomeType}`,
      params,
    )

    return object
  }

  static async getAttendanceList(
    params: AttendancePayload,
  ): Promise<AttendingTableListProps[]> {
    const {
      data: { object },
    } = await coreApi.post(
      `paciente/filtrar/atendimentos`,
      AttendanceSearchMapper.toPersistence(params),
    )

    return object.map((AttendanceList: AttendanceListTypes) =>
      AttendanceListMapper.toDomain(AttendanceList),
    )
  }

  static async postUnlinkProfessional(
    payload: UnlinkProfessional,
  ): Promise<void> {
    await coreApi.post(
      `/v2/linkPatientProfessional/${payload?.patientId}/unlink`,
      payload,
    )
  }

  static async getServicesDetailList(
    id: string,
  ): Promise<ServiceDetailsListData> {
    const {
      data: { object },
    } = await coreApi.get(`backoffice/atendimento/${id}`)

    return PatientsServicesDetailsMapper.toDomain(object)
  }

  static async exportAttendanceReport(
    attendanceId: string | number,
  ): Promise<void> {
    const { data } = await coreApi.get(
      `atendimento/${attendanceId}/exportar-relatorio`,
      { responseType: 'blob' },
    )

    downloadFiles(data, `relatorio-atendimento-${attendanceId}.pdf`)
  }

  static async getPatientDatailsData(id: string): Promise<PatientData> {
    const {
      data: { object },
    } = await coreApi.get(`paciente/obter/paciente/informacao-triagem/${id}`)

    return PatientDataMapper.toDomain(object)
  }

  static async getHistoryData(
    params?: DataResults,
  ): Promise<linkedPsychologists> {
    const {
      data: { object },
    } = await coreApi.get(
      `paciente/listar/historico/vinculo/profissionais/${params?.patientId}`,
      {
        params: ParamsDataMapper.toDomain(params),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return {
      data: object?.data?.map(HistoryDataMapper.toDomain),
      totalResults: object?.total,
    }
  }

  static async getPatientDetailsList(id: number): Promise<PatientDetails> {
    const {
      data: { object },
    } = await coreApi.get(`paciente/detalhar-backoffice/${id}`)

    return PatientDetailsMapper.toDomain(object)
  }

  static async getProfessionalByPatientName(
    patientId: number,
  ): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get(
      `profissional/v2/list/professionals-by-patient/${patientId}`,
    )
    return object?.map((professional: ProfessionalData) =>
      ProfessionalByPatientNameMapper.toDomain(professional),
    )
  }

  static async getCallDetails(id: string): Promise<CallsDetailsMapper[]> {
    const {
      data: { object },
    } = await coreApi.get(`chamada/detalhar-com-log/${id}`)

    return object?.map(CallsDetailsListMapper.toDomain)
  }

  static async getUsers(id: string): Promise<GetUserMapper> {
    const {
      data: { object },
    } = await coreApi.get(`backoffice/usuario/${id}`)

    return ParticipantsMapper.toDomain(object)
  }

  static async getOutcomeList(id: number): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `desfecho/listar/cobranca-desfecho-manual-enums/?idAtendimento=${id}`,
    )

    return object
  }

  static async reasonChargeback(): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `backoffice/listar/motivos-de-estorno`,
    )

    return object
  }

  static async getStatusAttendance(): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `atendimento/listar/enums-status-atendimento/paciente-backoffice`,
    )
    return object
  }

  static async getPaymentSituation(): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `atendimento/listar/enums-situacao-pagamento/paciente-backoffice`,
    )
    return object
  }

  static async getAllOutcome(): Promise<AttendingOutcomeListTypeMapper> {
    const {
      data: { object },
    } = await coreApi.get(`desfecho/obter/todos`)

    return object?.map((outcome: OutcomeDataResponse) =>
      AttendingOutcomeListMapper.toDomain(outcome),
    )
  }

  static async getCollectionAttemptsOrOutcome(
    idService: string,
  ): Promise<CollectionAttemptsTypes[]> {
    const {
      data: { object },
    } = await coreApi.get(
      `backoffice/cobranca-manual/atendimento/${idService}/obter/historico`,
    )
    return object?.map((collectionAttempsList: CollectionAttemptsListTypes) =>
      CollectionAttemptsListMapper.toDomain(collectionAttempsList),
    )
  }

  static async getCreditCard(
    idService: number,
  ): Promise<CreditCardResponseTypes[]> {
    const {
      data: { object },
    } = await coreApi.get(
      `backoffice/cobranca-manual/atendimento/${idService}/cartoes-credito`,
    )
    return object?.map((creditCardList: CreditCardTypes) =>
      CreditCardListMapper.toDomain(creditCardList),
    )
  }

  static async getGenerateNote(idPatientPag: number): Promise<boolean> {
    const {
      data: { object },
    } = await coreApi.get(`enotas/gerar/idpagamento/${idPatientPag}`)
    return object
  }

  static async searchImmediateAttachment(
    id: number,
  ): Promise<ViewOrAttachFilesTypes[]> {
    const {
      data: { object },
    } = await coreApi.get(`appointment/${id}/attachment`)

    return object?.map((immediateAttachment: ImmediateAttachment) =>
      ViewOrAttachFilesMapper.toDomain(immediateAttachment),
    )
  }

  static async sendImmediateAttachment(payload: SendAttachment): Promise<void> {
    await coreApi.post(`appointment/${payload.id}/attachment`, payload.file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  static async removeImmediateAttachment(
    data: RemoveAttachment,
  ): Promise<void> {
    await coreApi.delete(
      `appointment/${data.appointmentId}/attachment/${data.attachmentId}`,
    )
  }

  static async rescheduleAppointment(
    payload: PayloadReschedule,
  ): Promise<void> {
    await coreApi.post(
      `atendimento/reagendar`,
      RescheduleAppointmentMapper.toPersistence(payload),
    )
  }

  static async getPsychologistSearchList(
    queryParams: PsychologistSearchListParams,
  ): Promise<PsychologistSearchList> {
    const {
      data: { object },
    } = await coreApi.get(`pv/psicologos/v2`, {
      params: PsychologistSearchListMapper.toPersistence(queryParams),
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'comma', encode: false })
      },
    })

    return {
      psychologistList: object?.items?.map(
        PsychologistSearchListDataMapper.toDomain,
      ),
      total: object?.total,
    }
  }

  static async linkPsychologist(params: Record<string, number>): Promise<void> {
    await coreApi.post(
      `v2/link-patient-professional/${params?.patientId}/${params?.professionalId}`,
    )
  }

  static async create(patientData: FormRegisterPatient) {
    await coreApi.post(
      '/paciente/backoffice/salvar',
      RegisterPatientMapper.toPersistence(patientData),
    )
  }

  static async edit(
    patientData: FormRegisterPatient & Partial<RegisterPatientData>,
  ) {
    await coreApi.post(
      '/paciente/backoffice/salvar',
      RegisterPatientMapper.toPersistence(patientData),
    )
  }

  static async getPatientData(patientId: string) {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<RegisterPatientData>>(
      `paciente/detalhar-backoffice/${patientId}`,
    )

    return RegisterPatientMapper.toDomain(object)
  }

  static async uploadPicturePatient({
    file,
    patientId,
  }: UploadPicturePatientProps) {
    const formData = new FormData()
    formData.append('file', file)

    const response = await coreApi.post(
      `/paciente/upload/foto/backoffice`,
      formData,
      {
        headers: {
          paciente: patientId,
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return response
  }

  static async checkEligibility(payload: EligibilityRequestBody) {
    const { data } = await coreApi.post(
      '/integration/app-empresa-externa/elegibilidade/backoffice-validar',
      SendEligibilityCheck.toPersistence(payload),
    )

    return EligibilityMapper.toDomain(data?.object)
  }

  static async checkEligibilityWellhub(queryParams: EligibilityWellhubParams) {
    const { idPatient, ...paramsWithoutId } = queryParams
    const { data } = await coreApi.get(
      `/cliente-externo/wellhub/pacientes/validar-plano/${idPatient}`,
      {
        params: EligibilityWellhub.toPersistence(paramsWithoutId),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return EligibilityWellhub.toDomain(data?.object)
  }

  static async smartSearchAnalysis(queryParams: SmartSearchProfessional) {
    const { professionalId } = queryParams
    const { data } = await coreApi.get(
      `/internal/professionals/${professionalId}/search/summary?`,
      {
        params: SmartSearchAnalysisParam.toPersistence(queryParams),
      },
    )

    return SmartSearchAnalysisData.toDomain(data?.object)
  }
}

export { PatientServices }
